import React from 'react';
import { useParams } from 'react-router-dom';

import { selectMostRecentAircraft } from 'ff/debrief/utils';
import { Vspeeds } from 'ff/debrief/models';
import {
    useCreateVspeedOverridesMutation,
    useGetAircraftListQuery,
    useGetTracklogByIdQuery,
    useGetVSpeedOverridesQuery,
    useUpdateVspeedOverridesMutation,
} from 'ff/debrief/features/TracklogApi';

export const useCurrentAircraft = () => {
    const params = useParams<{ tracklogId: string }>();
    const selectedTracklogId = params.tracklogId;
    const { data: tl } = useGetTracklogByIdQuery(selectedTracklogId, {
        skip: !selectedTracklogId,
    });
    const { currentData: aircraftList, isSuccess } = useGetAircraftListQuery();

    const currentAircraft = React.useMemo(() => {
        return aircraftList && tl?.tailNumber
            ? selectMostRecentAircraft(aircraftList, tl.tailNumber)
            : null;
    }, [isSuccess, tl?.tailNumber]);

    const { currentData: vSpeeds } = useGetVSpeedOverridesQuery(
        currentAircraft?.uuid,
        {
            skip: !currentAircraft,
        }
    );

    const [createOverrides, createStatus] = useCreateVspeedOverridesMutation();
    const [updateOverrides, updateStatus] = useUpdateVspeedOverridesMutation();

    const setOverrides = (newOverrides: Vspeeds) => {
        if (vSpeeds?.overrodeVSpeeds) {
            return updateOverrides({
                aircraftObjectId: currentAircraft?.uuid,
                overrides: newOverrides,
            }).unwrap();
        } else {
            return createOverrides({
                aircraftObjectId: currentAircraft?.uuid,
                overrides: newOverrides,
            }).unwrap();
        }
    };

    return {
        currentAircraft: currentAircraft,
        isAircraftKnown: Boolean(currentAircraft),
        standardSpeeds: vSpeeds?.defaultVSpeeds,
        vSpeedOverrides: vSpeeds?.overrodeVSpeeds,
        setOverrides: setOverrides,
        createStatus: createStatus,
        updateStatus: updateStatus,
    };
};
